<template>
  <div id="wrap-reviews">

    <div v-if="!busy">
      <loading :active.sync="busy"/>
      <section id="header-reviews">
        <div id="title-reviews">
          <div>{{ $t("lab.my_reviews") }}</div>
        </div>
        <div id="search-reviews" v-show="!!sorted_notes.length">
          <v-text-field
            v-model="search_keyword"
            hide-details
            solo flat
            background-color="grey lighten-5"
            clearable
            single-line
            append-icon="mdi-magnify"
            placeholder="search...">
          </v-text-field>
        </div>
      </section>

      <section id="content-toolbar">
        <div id="toolbar-left">
          <div v-show="!!visible_notes.length">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn small icon color="#c1c3c9">
                    <v-icon small>mdi-sort-descending</v-icon>
                  </v-btn>
                </div>
              </template>
              <v-list dense>
                <v-list-item @click="sort_by=0">
                  {{ $t('sorting.author_a') }}
                  <v-icon v-if="sort_by==0" color="green" small>mdi-check</v-icon>
                </v-list-item>
                <v-list-item @click="sort_by=1">
                  {{ $t('sorting.author_d') }}
                  <v-icon v-if="sort_by==1" color="green" small>mdi-check</v-icon>
                </v-list-item>
                <v-list-item @click="sort_by=3">
                  {{ $t('sorting.date_a') }}
                  <v-icon v-if="sort_by==3" color="green" small>mdi-check</v-icon>
                </v-list-item>
                <v-list-item @click="sort_by=2">
                  {{ $t('sorting.date_d') }}
                  <v-icon v-if="sort_by==2" color="green" small>mdi-check</v-icon>
                </v-list-item>
                <v-list-item @click="sort_by=4">
                  {{ $t('sorting.title_a') }}
                  <v-icon v-if="sort_by==4" color="green" small>mdi-check</v-icon>
                </v-list-item>
                <v-list-item @click="sort_by=5">
                  {{ $t('sorting.title_d') }}
                  <v-icon v-if="sort_by==5" color="green" small>mdi-check</v-icon>
                </v-list-item>
                <v-list-item @click="sort_by=7">
                  {{ $t('sorting.modified_date_a') }}
                  <v-icon v-if="sort_by==7" color="green" small>mdi-check</v-icon>
                </v-list-item>
                <v-list-item @click="sort_by=6">
                  {{ $t('sorting.modified_date_d') }}
                  <v-icon v-if="sort_by==6" color="green" small>mdi-check</v-icon>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>

        <div id="toolbar-right" v-show="!!visible_notes.length">
          <div>
            <span v-if="!!num_docs">{{ index_page * num_docs_page + 1 }}</span>
            <span v-else>0</span>
            <span>-</span>
            <span v-if="(index_page + 1) * num_docs_page>num_docs">{{ num_docs }}</span>
            <span v-else>{{ (index_page + 1) * num_docs_page }}</span>
            <span>/</span>
            <span>{{ num_docs }}</span>
          </div>
          <div v-if="num_pages>1">
            <v-btn icon small @click="index_page-=1" :disabled="index_page==0">
              <v-icon color="#bac2cc">mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn icon small @click="index_page+=1" :disabled="index_page+1==num_pages">
              <v-icon color="#bac2cc">mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </div>
      </section>

      <section v-if="expired">
        <div class="expired-contents-meta">
          <span class="word-break">도큐먼트에 남긴 모든 리뷰를 한 눈에 모아볼 수 있습니다.</span>
          <span class="word-break">검색을 통해 회원님의 리뷰를 손쉽게 확인하세요.</span>
        </div>
        <div class="expired-contents-meta">
           리뷰 모아보기는 <b>프리미엄 회원</b>에게 제공됩니다.
        </div>
        <div class="expired-contents-btn">
          <v-btn depressed dark color="#ff5193"
            :to="{name: 'signup'}">프리미엄 구독하기</v-btn>
        </div>
      </section>

      <section v-else-if="!sorted_notes.length" class="empty-wrap">
        <div class="empty-contents-title">
          {{ $t('reviews.empty_title') }}
        </div>
        <div class="empty-contents-meta">
          {{ $t('reviews.empty_subtitle_1') }}
        </div>
      </section>

      <section v-else-if="!!search_keyword&&!filtered_notes.length" class="empty-wrap">
        <div class="empty-contents-title">찾으시는 결과가 없네요 😅</div>
        <div class="empty-contents-meta">다른 키워드를 사용해보시겠어요?</div>
      </section>

      <section v-else>
        <div class="card-wrap" v-for="(note, index) in visible_notes" :key="index"
          @click="detail_key=note.doc_key;review_detail_visible=true">
          <!-- Card header -->
          <div class="card-header">
            <div class="card-doctype" :style="{'background-color': doc_types[parseInt(note.doc_type)]['color']}"></div>
            <v-clamp :max-lines="1" autoresize class="card-title">{{ note.title }}</v-clamp>
          </div>
          <div class="card-meta">
            <div>
              <v-clamp :max-lines="1" autoresize class="card-authors">{{ note.authors_iso690 }}</v-clamp>
              <div class="card-year">({{ note.year }})</div>
            </div>
            <div class="card-date">{{ $t('reviews.modified') }}: {{ note.modified_ts.substr(0, 10) }}</div>
          </div>
          <div class="card-review">
            <!-- <v-clamp :max-lines="1" autoresize v-if="!!note.note" 
              v-html="parseNote(note.note)" class="card-review-note">
            </v-clamp> -->
            <v-clamp :max-lines="3" autoresize v-if="!!note.note" 
              class="card-review-note">
              {{ note.visible_note }}
            </v-clamp>
          </div>
        </div>
      </section>
    </div>

    <!-- Modals -->
    <modal-review-detail
      :dialog.sync="review_detail_visible"
      :dockey="detail_key">
    </modal-review-detail>

    <modal-expired-reviews
      :dialog.sync="expired_reviews_visible">
    </modal-expired-reviews>

  </div>
</template>

<script>
import VClamp from 'vue-clamp'
import { mapGetters, mapMutations } from 'vuex'
import { doc_types } from '../../../custom/model'
import { sortNotes } from '../../../custom/function'

export default {
  metaInfo() {
    return {
      title: "Reviews"
    }
  },

  components:{
    VClamp,
  },

  data() {
    return {
      busy: false,
      doc_types,
      sort_by: 7,
      sorted_notes: [],
      filtered_notes: [],
      visible_notes: [],

      num_docs: 0,
      num_pages: 0,
      index_page: 0,
      num_docs_page: 50,

      search_keyword: '',

      review_detail_visible: false,
      detail_key: null,
    }
  },

  computed: {
    ...mapGetters({
      notes: 'notes/document_notes',
      expired: 'auth/is_expired',
      expired_reviews_visible: 'modal/expired_reviews_visible',
    }),
  },

  async created() {
    if (!this.expired) {
      try {
        this.busy = true
        await this.$store.dispatch('notes/getDocumentNotes')
      } finally {
        this.busy = false
      }
    } else {
      this.$router.replace({name: 'lab'})
    }
  },

  watch: {
    notes: {
      handler(val) {
        this.updateNotes()
      },
      deep: true,
    },

    sort_by(val) {
      this.updateNotes()
    },

    filtered_notes(val) {
      this.num_docs = val.length
      this.num_pages = Math.ceil(this.num_docs/this.num_docs_page)
      if (!!val.length && this.index_page>=this.num_pages) {
        this.index_page = 0
      }
      else { this.updateVisibleNotes() }
    },

    index_page(val) {
      this.updateVisibleNotes()
    },

    search_keyword: {
      handler(val) {
        if (!val || !val.length) {
          this.filtered_notes = this.sorted_notes
        } else {
          this.searchList(val)
        }
      },
    },
  },

  methods: {
    ...mapMutations({
      showExpiredReviewsModal: 'modal/showExpiredReviews'
    }),

    sortNotes,
    
    updateNotes() {
      let new_notes = []
      if (!!this.notes.length) {
        new_notes = this.sortNotes(this.notes, parseInt(this.sort_by))
        new_notes.forEach(note => {
          var temp = document.createElement('div')
          temp.innerHTML = this.parseNote(note.note)
          note.visible_note = (temp.textContent || temp.innerText || "")
        })
      }
      this.sorted_notes = new_notes
      this.filtered_notes = this.sorted_notes
    },

    parseNote(note) {
      if (note == null) { return null }
      else {
        return JSON.parse(note).data
      }
    },

    updateVisibleNotes() {
      this.visible_notes = 
        this.filtered_notes.slice(this.index_page*this.num_docs_page, (this.index_page+1)*this.num_docs_page)
    },

    searchList(keyword) {
      keyword = keyword.toLowerCase()
      this.filtered_notes = this.sorted_notes.filter(v => {
        return v.authors_iso690.toLowerCase().includes(keyword) ||
        (!!v.date && v.date.toLowerCase().includes(keyword)) ||
        v.visible_note.includes(keyword) ||
        v.title.toLowerCase().includes(keyword)
      })
    },
  },
}
</script>

<style scoped>
  #wrap-reviews {
    padding: 20px 40px;
  }

  /* Header */

  #header-reviews {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  #title-reviews {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    color: #323334;
  }

  /* Content toolbar */

  #content-toolbar {
    margin: 12px 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  #toolbar-right {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    color: #858d97;
  }

  #toolbar-right div {
    margin-left: 12px;
  }

  /* Content Card */

  .card-wrap {
    border: 1px solid #dde2e5;
    background-color: white;
    margin-bottom: 20px;
  }

  .card-wrap:hover {
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2);
    cursor: pointer;
  }

  .card-header {
    padding: 20px 20px 0 20px;
  }

  .card-header {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .card-doctype {
    height: 10px;
    width: 10px;
    border-radius: 50%;
    display: inline-block;
    margin-right: 8px;
  }

  .card-title {
    font-size: 16px;
    font-weight: 600;
    color: #485158;
  }

  .card-meta {
    padding: 10px 20px 0 20px;
    display: grid;
    grid-template-columns: 50% 50%;
  }

  .card-meta > div {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .card-authors, .card-year {
    font-size: 12px;
    color: #858d97;
  }

  .card-date {
    color: #858d97;
    display: flex;
    justify-content: flex-end;
  }

  .card-review {
    display: flex;
    flex-direction: column;
    margin-top: 12px;
  }

  .card-review-note {
    padding: 20px;
    background-color: #fafafb;
  }

  /* Empty */

  .empty-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 32px;
  }

  .empty-contents-title {
    font-size: 20px;
    padding-bottom: 20px;
  }

  .empty-contents-meta {
    font-size: 14px;
    padding-bottom: 20px;
    color: rgb(0, 0, 0, .4);
  }

  .expired-contents-meta {
    font-size: 14px;
    padding-top: 20px;
    text-align: center;
  }

  .expired-contents-btn {
    margin-top: 20px;
    text-align: center;
  }

</style>


// WEBPACK FOOTER //
// src/components/spa/lab/Reviews.vue